import { EditApproverMeta, EditApproverPayload } from 'types/store/EditApprover';
import { createAsyncReducer } from 'utils/Redux';

import { editApproverActions } from '../actions';

export default createAsyncReducer<EditApproverMeta, EditApproverPayload>(editApproverActions);
